<script>
	export let totalItems = 0;
	export let currentPage = 1;
	export let totalPages = 1;
	export let pageSize = 10;
	export let pageSizes = [10, 15, 20, 25, 30, 50, 100];

	export let onPageSizeChange;
	export let onReload;
	export let onRegist;
	export let onRegistServer;
	export let onBulkRegist = null;
</script>

<div class="d-flex p-2">
	<div class="nav-item d-flex align-items-center">
		<small class="text-muted">
			Total: {totalItems} | Page: {currentPage}/{totalPages}
		</small>
		<select class="form-select form-select-sm ms-2" style="width: auto;" bind:value={pageSize} on:change={(e) => onPageSizeChange(e)}>
			{#each pageSizes as size}
				<option value={size}>{size}개씩 보기</option>
			{/each}
		</select>
	</div>
	&nbsp;
	<div class="ms-auto">
		<div class="input-group justify-content-end">
			<button class="btn btn-sm btn-outline-primary" on:click={onReload}>Reload</button>
			{#if onRegist}
				<button class="btn btn-sm btn-primary" on:click={onRegist}>신규등록</button>
			{/if}
			{#if onBulkRegist}
				<button class="btn btn-sm btn-warning" on:click={onBulkRegist}>일괄등록</button>
			{/if}
			{#if onRegistServer}
				<button class="btn btn-sm btn-outline-primary" on:click={onRegistServer}>서버적용</button>
			{/if}
		</div>
	</div>
</div>
